module.exports = __webpack_public_path__ + "static/media/banner_sendero.17d54a0d.png";